import { Component, inject } from '@angular/core';
import { MessagingService } from './core/services/messaging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'iArista CRM';
  messagingService = inject(MessagingService);

  async ngOnInit(): Promise<void> {
    // Service auto-initializes itself, so we just need to wait for it to be ready
    console.log('App component initialized, FCM service initializing...');

    // Wait for service to be ready before doing other initialization
    this.messagingService.isInitialized$.subscribe(isReady => {
      if (isReady) {
        console.log('FCM service is ready!');
      }
    });
  }
}
